module.exports = __webpack_public_path__ + "img/redsox2.da170f11.jpg";